/**
 * dir-w | backOffice
 * Application configuration
 *
 * Last update : July 27, 2024 | @rizkiprasetya
 */

import { HttpHeaders, HttpParams } from "@angular/common/http";

export class Configuration {
  // application Info
  public static appDeveloper: string = 'dir/w';
  public static appTitle: string = 'Sport Data Management';
  public static appYear: string = '2026';
  public static appVersion: string = '1.0.45';
  public static appType: string = 'backOffice'; //frontEnd
  // active profile
  public static Profile: string = 'dir-w';
  // base URL development
  // public static baseURL: string = 'http://127.0.0.1:8000'
  // base URL production
  public static baseURL: string = 'https://backoffice.dampal.com';
  // api URL development
  //public static apiURL: string = 'http://127.0.0.1:8000/api';
  // api URL production
  public static apiURL: string = 'https://fdm.dampal.com/api';
  // token expired date (seconds)
  public static tokenExpiredTime = 7200; // 2 hours
  // default page record to display on every page list
  public static pageSize: number = 8;

  /**
   * Generate HttpHeaders for Http Options parameters
   * @param token string | null
   * @returns `HttpHeaders`
   */
  public static generateHttpHeaders(
    token: string | null = null,
    useContentType: boolean = true,
  ): HttpHeaders {
    // Default headers
    let httpHeaders = new HttpHeaders();

    // for upload file don't use content type
    if (useContentType)
      httpHeaders = httpHeaders.append('Content-Type', 'application/json');

    // check this origin to spesific url domain when goes live
    // httpHeaders = httpHeaders.append('Access-Control-Allow-Origin', '*'); this.baseURL
    httpHeaders = httpHeaders
      .append('Access-Control-Allow-Origin', '*')
      .append(
        'Access-Control-Allow-Methods',
        'GET, PATCH, POST, PUT, DELETE, OPTIONS',
      )
      .append('Access-Control-Allow-Private-Network', 'true')
      .append('Access-Control-Allow-Credentials', 'true')
      .append('Access-Control-Allow-Headers', 'content-type')
      .append('Accept', 'application/json');

    // if token available
    if (token != '' || token != null) {
      httpHeaders = httpHeaders.append('Authorization', 'Bearer ' + token);
    }

    // return the HttpHeaders
    return httpHeaders;
  }

  /**
   * Generate HttpParams for Http Request
   * @param params Array<{ key: string; value: string }>
   * @returns `HttpParams`
   */
  public static generateHttpParams(
    params: Array<{ key: string; value: string }>,
  ): HttpParams {
    let httpParams = new HttpParams();
    params.forEach((item) => {
      httpParams = httpParams.append(item.key.toString(), item.value);
    });
    return httpParams;
  }
}
